var _linearGradient, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 24,
    height: 24
  }, props), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "facebook_svg__a",
    x1: -277.375,
    x2: -277.375,
    y1: 406.602,
    y2: 407.573,
    gradientTransform: "matrix(40 0 0 -39.7778 11115.001 16212.334)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0062e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19afff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#facebook_svg__a)",
    d: "M32 6C17.642 6 6 17.642 6 32c0 13.035 9.603 23.799 22.113 25.679V38.89H21.68v-6.834h6.433v-4.548c0-7.529 3.668-10.833 9.926-10.833 2.996 0 4.583.223 5.332.323v5.965h-4.268c-2.656 0-3.584 2.52-3.584 5.358v3.735h7.785l-1.055 6.834h-6.73v18.843C48.209 56.013 58 45.163 58 32 58 17.642 46.359 6 32 6z"
  })));
}

export default SvgFacebook;